export const LOGIN_NUMBER_VARIFICATION = "LOGIN_NUMBER_VARIFICATION";
export const LOGIN_NUMBER_VARIFICATION_SUCCESS =
  "LOGIN_NUMBER_VARIFICATION_SUCCESS";
export const LOGIN_NUMBER_VARIFICATION_ERROR =
  "LOGIN_NUMBER_VARIFICATION_ERROR";
